// extracted by mini-css-extract-plugin
module.exports = {"root":"OrderDirect_root__3s6J7","button":"OrderDirect_button__19LFd","icon":"OrderDirect_icon__2m5XW"};